import { reduxInit } from '@driftt/traffic-control'

import config from 'config'

export const { createReducer, createAction, mergeReducers } = reduxInit(
  config.REDUX_ACTION_NAMESPACE
)
